import classNames from 'classnames';
import React from 'react';
import { CITY_GRADIENTS } from '../../../../constants';
import { getRandomAsset } from '../../utils';
import './cityBrowseHeaderImage.scss';
import { splitCityName } from './utils';

interface CityImageProps {
    currentPlace?: string;
    cityImage?: string;
    citySmallImage?: string;
    shouldHideMask?: boolean;
    imgClassNames?: string;
    experiments?: any;
    mobile?: boolean;
}

const CityImage = ({
    cityImage,
    currentPlace,
    imgClassNames,
}: CityImageProps) => {
    let component = null;

    if (cityImage) {
        component = (
            <img
                //HTML Img Definition doesnt support fetchpriority but it
                //is supported in chrome and edge with broader support coming
                //https://caniuse.com/mdn-html_elements_img_fetchpriority
                //eslint-disable-next-line
                //@ts-ignore
                fetchpriority="high"
                src={cityImage}
                alt={currentPlace}
                className={imgClassNames}
                loading="eager"
                height={700}
                width={450}
            />
        );
    }

    return component;
};

const HeaderImage = ({
    currentPlace,
    cityImage,
    citySmallImage,
    shouldHideMask,
}: CityImageProps) => {
    const imgClassNames = classNames(
        'full-width-img city-browse-header__image',
        {
            'city-browse-header__fallback-image': !shouldHideMask,
            'city-browse-header__image-absolute': shouldHideMask,
        },
    );

    let component = (
        <CityImage
            cityImage={cityImage}
            citySmallImage={citySmallImage}
            currentPlace={currentPlace}
            imgClassNames={imgClassNames}
        />
    );

    if (!shouldHideMask) {
        const { firstCityName, secondCityName } = splitCityName(
            currentPlace || '',
        );

        const fallbackContainerClassName = classNames(
            'city-browse-header__fallback_container',
            {
                [`${getRandomAsset(CITY_GRADIENTS, currentPlace || '')}`]:
                    !cityImage,
            },
        );

        component = (
            <>
                <div className={fallbackContainerClassName}>
                    {component}
                    <div className="eds-text-weight--light city-browse-header__fallback-text city-browse-header__fallback-text-1">
                        {firstCityName}
                    </div>
                    <div className="eds-text-weight--light city-browse-header__fallback-text city-browse-header__fallback-text-2">
                        {secondCityName}
                    </div>
                    <img
                        //HTML Img Definition doesnt support fetchpriority but it
                        //is supported in chrome and edge with broader support coming
                        //https://caniuse.com/mdn-html_elements_img_fetchpriority
                        //eslint-disable-next-line
                        //@ts-ignore
                        fetchpriority="high"
                        src="/static/images/search/fall-back-mask.png"
                        alt=""
                        className="city-browse-header__fallback-image-mask"
                    />
                </div>
                <div className="city-browse-header__fallback-bleed-mask"></div>
            </>
        );
    }

    return component;
};

export class CityBrowseHeaderImage extends React.PureComponent<CityImageProps> {
    render() {
        const {
            currentPlace,
            cityImage,
            citySmallImage,
            shouldHideMask,
            experiments,
            mobile,
        } = this.props;

        return (
            <div className="city-browse-header__image--container">
                <HeaderImage
                    currentPlace={currentPlace}
                    cityImage={cityImage}
                    citySmallImage={citySmallImage}
                    shouldHideMask={shouldHideMask}
                    experiments={experiments}
                    mobile={mobile}
                />
            </div>
        );
    }
}
